<template>
  <div :class="classModifiers">
    <div class="nav-browse__container">
      <button
        v-if="showSidebarToggle"
        :class="[
          'nav-browse__sidebar-toggle',
          { 'nav-browse__sidebar-toggle--active': sidebarVisible },
        ]"
        @click="toggleSidebar"
      >
        <sidebar-icon />
      </button>
      <div class="nav-browse__slide nav-browse__slide--categories">
        <div class="nav-browse__item">
          <span
            class="nav-browse__link nav-browse__link--categories"
            @click="toggleCategoriesLabel"
          >
            <span :class="categoriesIcon"></span>
            <transition name="nav-browse"
              ><span
                class="nav-browse__link-text nav-browse__link-text--categories"
                v-if="isCategoriesLabelVisible"
                >Categories:</span
              ></transition
            >
          </span>
        </div>
      </div>
      <div v-for="item in externalBrowseHeaders" :key="item.headerId" class="nav-browse__slide">
        <div class="nav-browse__item">
          <router-link v-if="item.name" class="nav-browse__link" :to="{ name: item.name }">
            <span v-if="item.icon" :class="iconClassModifiers(item)"></span>
            <h2>{{ item.title }}</h2>
          </router-link>
          <a v-else-if="item.href" class="nav-browse__link" :href="item.href" v-outer-link>
            <span v-if="item.icon" :class="iconClassModifiers(item)"></span>
            <h2>{{ item.title }}</h2>
          </a>
        </div>
      </div>
      <div v-if="isLayoutMobile" class="nav-browse__slide">
        <div class="nav-browse__item">
          <router-link
            class="nav-browse__link"
            :class="{ 'router-link-exact-active': isAllMarketsLinkActive }"
            :to="{ name: 'market-list', params: { headerId: 'all' } }"
          >
            <h2>All</h2>
          </router-link>
        </div>
      </div>
      <div v-for="item in categoryBrowseHeaders" :key="item.headerId" class="nav-browse__slide">
        <div class="nav-browse__item">
          <router-link
            class="nav-browse__link"
            :to="{
              name: 'market-list',
              params: { headerId: item.headerId, headerUrl: item.headerUrl },
            }"
          >
            <h2>{{ item.name }}</h2>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./nav-browse.js"></script>
<style src="./nav-browse.scss" lang="scss"></style>
